module.exports = __webpack_public_path__ + "img/bul_menu_solution.530257d2.svg";